export default "__VITE_ASSET__DcdNgDl5__"